import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import NextGenDonutsmpUtilities from "./sections/NextGenDonutsmpUtilities";
import ExpertSolutionsForEveryPipe from "./sections/ExpertSolutionsForEveryPipe";
import LEnjeuDeMuna from "./sections/LEnjeuDeMuna";
import MeasurableInclusion from "./sections/MeasurableInclusion";
import FureverStories from "./sections/FureverStories";
import ReadyToStartYourJourney from "./sections/ReadyToStartYourJourney";
import FooterFornitoreGas from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <NextGenDonutsmpUtilities />
      <ExpertSolutionsForEveryPipe />
      <LEnjeuDeMuna />
      <MeasurableInclusion />
      <FureverStories />
      <ReadyToStartYourJourney />
      <FooterFornitoreGas />
    </div>;
}